import { z } from 'zod';

// Step 1: Group Leader info
export const stepGroupLeaderSchema = z.object({
  isGroupLeader: z.boolean(),
  phone: z.string().min(1, 'Phone number is required'),
  familyConnection: z.string().optional().or(z.literal('')),
});

// Step 2: Family Members list
export const familyMemberSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  ageGroup: z.enum(['adult', 'teen', 'youth', 'child', 'infant'], {
    message: 'Age group is required',
  }),
  relationship: z.string().min(1, 'Relationship is required'),
  email: z.string().email('Invalid email address').optional().or(z.literal('')),
});

export const stepFamilyMembersSchema = z.object({
  familyMembers: z.array(familyMemberSchema).min(1, 'At least one family member is required'),
});

// Step 3: Villa Preference (all optional — advisory only)
export const stepVillaPreferenceSchema = z.object({
  villaTypePreference: z.string().optional(),
  flexibilityNotes: z.string().optional(),
  roomConfigNotes: z.string().optional(),
});

// Step 4: Special Needs (dietary, allergies, accessibility per member)
export const memberNeedsSchema = z.object({
  dietaryRestrictions: z.array(z.string()),
  foodAllergies: z.string().optional(),
  accessibilityNeeds: z.string().optional(),
});

export const stepSpecialNeedsSchema = z.object({
  memberNeeds: z.array(memberNeedsSchema),
});

// Step 5: Review — no schema needed (read-only confirmation)

// Inferred types for use in form components
export type StepGroupLeaderForm = z.infer<typeof stepGroupLeaderSchema>;
export type StepFamilyMembersForm = z.infer<typeof stepFamilyMembersSchema>;
export type StepVillaPreferenceForm = z.infer<typeof stepVillaPreferenceSchema>;
export type StepSpecialNeedsForm = z.infer<typeof stepSpecialNeedsSchema>;
